export default [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' }
];
